import { WALLET_BONNET } from '../global-constants.js';
import { loadScript } from '../utils/loadScript.js';

// Insert the My Wallet Bonnet Shared Bundle
export const insertWalletBonnet = async (walletScriptHost) => {
	const scriptUrl = `${walletScriptHost}/${WALLET_BONNET}.js`;
	return loadScript(scriptUrl, { id: 'wallet-bonnet-bundle' });
}
